import React from 'react';
import ab from 'autobahn';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  updateNotifications,
  connectWebsocket,
  disconnectWebsocket,
  updateNewMessage,
  updateNewMessageFile,
  setOnline,
  setOffline
} from 'stores/actions';

class WebSocket extends React.Component {
  constructor( props ) {
    super( props );
    this.connection = null;
  }

  componentDidMount() {
    if( this.props.status === 'on' && !this.props.connected ) this.connectWebSocket( this.props.data );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.props.status !== nextProps.status ) {
      if( nextProps.status === 'on' ) {
        this.connectWebSocket( nextProps.data );
      } else {
        if( this.connection && this.props.data ) {
          try {
            this.connection.unsubscribe( `operator/${this.props.data.topicId}` );
            this.connection.close();
          } catch( e ) {
          }
        }
        if( nextProps.connected ) {
          this.props.disconnectWebsocket()
        }
      }
    }

    if( nextProps.messageData && _.get( this.props, 'messageData.date' ) !== _.get( nextProps, 'messageData.date' ) ) {
      this.connection.publish( `operator/${nextProps.data.topicId}`, {
        action: 'chatMessage',
        data: nextProps.messageData
      } );
    }

    if( nextProps.connected && nextProps.checkOnlineData && _.get( this.props, 'checkOnlineData.date' ) !== _.get( nextProps, 'checkOnlineData.date' ) ) {
      this.connection.publish( `operator/${nextProps.data.topicId}`, {
        action: 'chatIsConnected',
        data: {
          channelId: nextProps.checkOnlineData.channelId
        }
      } );
    }
  }

  connectWebSocket( data ) {
    this.connection = new ab.Session( `${process.env.WEBSOCKET_IP}?token=${data.chatToken}`,
      () => {
        console.info( 'WebSocket Connected' );
        this.props.connectWebsocket()

        try {
          this.connection.subscribe( `operator/${data.topicId}`, ( topic, msg ) => {
              console.log( 'msg', msg );
              switch( msg.action ) {
                case 'chatDisconnected':
                  this.props.setOffline( msg.data )
                  break;
                case 'chatConnected':
                  this.props.setOnline( msg.data )
                  break;
                default:
                  if( msg.data.ref ) this.props.updateNewMessageFile( msg.data )
                  else this.props.updateNewMessage( msg.data )
              }

            },
          );
        } catch( e ) {
          console.warn( 'Operator WebSocket connection closed' );
          this.props.disconnectWebsocket()
        }
      },
      ( error, msg ) => {
        console.warn( 'WebSocket connection closed' );
        this.props.disconnectWebsocket()
      },
      { 'skipSubprotocolCheck': true }
    );
  }

  render() {
    return <span/>
  }
}

const mapStateToProps = ( state ) => ( {
  user: state.user,
  status: state.websocket.status,
  data: state.websocket.data,
  connected: state.websocket.connected,
  messageData: state.websocket.messageData,
  checkOnlineData: state.websocket.checkOnlineData,
} );

const mapDispatchToProps = dispatch => ( {
  updateNotifications: ( data ) => {
    dispatch( updateNotifications( data ) );
  },
  connectWebsocket: () => {
    dispatch( connectWebsocket() );
  },
  disconnectWebsocket: () => {
    dispatch( disconnectWebsocket() );
  },
  updateNewMessage: ( data ) => {
    dispatch( updateNewMessage( data ) );
  },
  updateNewMessageFile: ( data ) => {
    dispatch( updateNewMessageFile( data ) );
  },
  setOnline: ( data ) => {
    dispatch( setOnline( data ) );
  },
  setOffline: ( data ) => {
    dispatch( setOffline( data ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( WebSocket );



// WEBPACK FOOTER //
// ./components/Websocket/index.js